//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './PatientCommentClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetPatientCommentQueryParameters = {
  patientId: number ;
}

export type EditPatientCommentQueryParameters = {
  id: number ;
}

export type RemovePatientCommentQueryParameters = {
  id: number ;
}

export function getUrl(patientId: number): string {
  let url_ = getBaseUrl() + "/api/patient-comments/{patientId}";
if (patientId === undefined || patientId === null)
  throw new Error("The parameter 'patientId' must be defined.");
url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.PatientCommentDto[], unknown, Types.PatientCommentDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PatientCommentDto[], unknown, Types.PatientCommentDto[]>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(patientId: number): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId,  } = params[0] as GetPatientCommentQueryParameters;

    return trimArrayEnd([
        'PatientCommentClient',
        'get',
        patientId as any,
      ]);
  } else {
    return trimArrayEnd([
        'PatientCommentClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.PatientCommentDto[], TError = unknown>(dto: GetPatientCommentQueryParameters, options?: Omit<UseQueryOptions<Types.PatientCommentDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets all comments for patient.
 */
export function useGetQuery<TSelectData = Types.PatientCommentDto[], TError = unknown>(patientId: number, options?: Omit<UseQueryOptions<Types.PatientCommentDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.PatientCommentDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PatientCommentDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let patientId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId,  } = params[0] as GetPatientCommentQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PatientCommentDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(patientId),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.PatientCommentDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all comments for patient.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.PatientCommentDto[] | undefined) => Types.PatientCommentDto[], patientId: number) {
  queryClient.setQueryData(getQueryKey(patientId),
    updater
  );
}

/**
 * Gets all comments for patient.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PatientCommentDto[] | undefined) => Types.PatientCommentDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function editUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/patient-comments/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function editMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'PatientCommentClient',
      'edit',
      id as any,
    ]);
}

/**
 * Edits a patient comment.
 * @param id The patient comment id.
 * @param dto Request parameter
 */
export function useEditMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.EditPatientCommentDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.EditPatientCommentDto, TContext> {
  const key = editMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.EditPatientCommentDto) => Client.edit(id, dto),
    mutationKey: key,
  });
}
  
type Edit__MutationParameters = EditPatientCommentQueryParameters & {
  dto: Types.EditPatientCommentDto;
}

/**
 * Edits a patient comment.
 * @param id The patient comment id.
 * @param dto Request parameter
 */
export function useEditMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Edit__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: EditPatientCommentQueryParameters}): UseMutationResult<void, unknown, Edit__MutationParameters, TContext> {
  const key = editMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Edit__MutationParameters) => Client.edit(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/patient-comments/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'PatientCommentClient',
      'remove',
      id as any,
    ]);
}

/**
 * Removes a patient comment.
 * @param id The patient comment id.
 */
export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemovePatientCommentQueryParameters

/**
 * Removes a patient comment.
 * @param id The patient comment id.
 */
export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemovePatientCommentQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/patient-comments";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'PatientCommentClient',
      'create',
    ]);
}

/**
 * Creates a patient comment.
 * @param dto Request parameter
 */
export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.PatientCommentDto, unknown, Types.CreatePatientCommentDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PatientCommentDto, unknown, Types.CreatePatientCommentDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreatePatientCommentDto) => Client.create(dto),
    mutationKey: key,
  });
}